// extracted by mini-css-extract-plugin
module.exports = {"button":"ListNftButton_button__Wyqzt"};